import Swiper from "swiper";
import {Navigation, Pagination, A11y} from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/effect-fade";


const initCorePrinciplesSlider = () => {
  const partners = document.querySelectorAll(".core-principles-swiper");

  partners.forEach(partner => {
    new Swiper(partner, {
      modules: [Navigation, Pagination, A11y],
      loop: true,
      slidesPerView: 1.1,
      spaceBetween: 24,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      a11y: {
        enabled: true,
        scrollOnFocus: false,
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: false,
      },
      breakpoints: {
        '768': {
          slidesPerView: 1.75,
        },
        '1024': {
          slidesPerView: 2.03,
        },
      },
    });
  })
}

window.addEventListener('load', () => {
  initCorePrinciplesSlider();
});
